import React, { useState } from 'react';
interface Credential {
  name: string;
  email: string;
  password: string;
  description: string;
}
interface LoginCredentialsHelperProps {
  onSelectCredential: (email: string, password: string) => void;
}
const LoginCredentialsHelper: React.FC<LoginCredentialsHelperProps> = ({
  onSelectCredential
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const credentials: Credential[] = [{
    name: 'Ajibola Oluga',
    email: 'ajibola@example.com',
    password: 'password123',
    description: 'User with applications across multiple ministries'
  }, {
    name: 'Osaro Igbinedion',
    email: 'osaro@example.com',
    password: 'password456',
    description: 'User with rejected education application and approved lands application'
  }, {
    name: 'Blessing Okonkwo',
    email: 'blessing@example.com',
    password: 'password789',
    description: 'User with pending payment for health application'
  }];
  return <div className="mt-6 border border-gray-200 rounded-lg overflow-hidden" data-id="element-395">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors" data-id="element-396">
        <div className="flex items-center" data-id="element-397">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-398">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-399" />
          </svg>
          Demo Credentials
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor" data-id="element-400">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-401" />
        </svg>
      </button>
      {isOpen && <div className="p-4 bg-white" data-id="element-402">
          <div className="text-xs text-gray-500 mb-3" data-id="element-403">
            Select a demo account to populate the login form:
          </div>
          <div className="space-y-3" data-id="element-404">
            {credentials.map((cred, index) => <div key={index} className="p-3 border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer" onClick={() => onSelectCredential(cred.email, cred.password)} data-id="element-405">
                <div className="flex justify-between items-center" data-id="element-406">
                  <div className="font-medium text-sm text-gray-900" data-id="element-407">
                    {cred.name}
                  </div>
                  <button className="text-xs text-green-600 hover:text-green-800 font-medium" data-id="element-408">
                    Use
                  </button>
                </div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-409">
                  {cred.email} / {cred.password}
                </div>
                <div className="text-xs text-gray-600 mt-2" data-id="element-410">
                  {cred.description}
                </div>
              </div>)}
          </div>
          <div className="mt-3 text-xs text-gray-500" data-id="element-411">
            Note: Each user has different applications and data to demonstrate
            various scenarios.
          </div>
        </div>}
    </div>;
};
export default LoginCredentialsHelper;